export default {
  // list
  'base_cargo_spec.query.cargoTypeId': '货物类型',
  'base_cargo_spec.query.cargoTypeId.placeholder': '请输入货物类型',
  'base_cargo_spec.query.specName': '规格名称',
  'base_cargo_spec.query.specName.placeholder': '请输入规格名称',
  'base_cargo_spec.column.cargoTypeId': '货物类型',
  'base_cargo_spec.column.specName': '规格名称',
  'base_cargo_spec.column.createBy': '创建人',
  'base_cargo_spec.column.updateBy': '更新人',
  'base_cargo_spec.column.createTime': '创建时间',
  'base_cargo_spec.column.updateTime': '更新时间',
  'base_cargo_spec.column.dataSource': '数据来源',
  'base_cargo_spec.column.remark': '备注',
  'base_cargo_spec.column.status': '状态',
  // edit
  'base_cargo_spec.edit.title': '编辑货物规格',
  'base_cargo_spec.add.title': '新增货物规格',
  'base_cargo_spec.edit.success': '编辑成功',
  'base_cargo_spec.add.success': '新增成功',
  'base_cargo_spec.form.cargoTypeId.required': '货物类型不能为空',
  'base_cargo_spec.form.specName.required': '规格名称不能为空',
  'base_cargo_spec.form.cargoTypeId': '货物类型',
  'base_cargo_spec.form.cargoTypeId.placeholder': '请输入货物类型',
  'base_cargo_spec.form.specName': '规格名称',
  'base_cargo_spec.form.specName.placeholder': '请输入规格名称',
}
